export const GET_INTEGRATION_SETTINGS = 'GET_INTEGRATION_SETTINGS'
export const SET_INTEGRATION_SETTINGS = 'SET_INTEGRATION_SETTINGS'
export const GET_DESTINATION_REQUESTS = 'GET_DESTINATION_REQUESTS'
export const VALIDATE_SETTINGS = 'VALIDATE_SETTINGS'
export const DELETE_CISCO_SETTINGS = 'DELETE_CISCO_SETTINGS'
export const ADD_DESTINATION_LIST = 'ADD_DESTINATION_LIST'
export const UPDATE_BLOCK_REQUEST = 'UPDATE_BLOCK_REQUEST'
export const GET_DESTINATION_LISTS = 'GET_DESTINATION_LISTS'
export const DELETE_DESTINATION_LIST = 'DELETE_DESTINATION_LIST'
